import { useDispatch, useSelector } from "react-redux"
import { RdxType, RestListContainer, RestResponseType } from "../../data/Types"
import { useUser } from "./useUser";
import { useEffect, useState } from "react";
import { CHANGE_ORGANIZATION_CURRENTORGANIZATION, CHANGE_ORGANIZATIONS_ALL, CHANGE_ORGANIZATIONS_LOADING_ORGANIZATIONS, CHANGE_ORGANIZATIONS_MYROLES, CHANGE_ORGANIZATIONS_MYUSERS, COOKIENAME_CURRENT_ORGANIZATION_ID, MyRolesType, OrganizationProStatus, OrganizationType, OrganizationUserRoleType } from "../../data/redux/organizationReducer";
import { useFetch } from "../data/useFetcher";
import Cookies from "js-cookie";
import { Helpers } from "../../data/Helpers";
import { AddingNewOrganizationViewStateType, CHANGE_UI_ADDINGNEWORGANIZATION } from "../../data/redux/uIReducer";
import { useLocation, useParams } from "react-router-dom";
import { OrderFormType } from "../../../components/ui/Simple/ReadMoreDialog";


export const OrganizationHelper = {
    isOwnerOrHidden: (e: OrganizationUserRoleType): boolean => {
        return e === "OWNER" || e === "HIDDEN";
    }
}

export const useOrganizationActions = () => {
    const dispatch = useDispatch();

    const allOrganizations = useSelector((state: RdxType) => state.organization?.allOrganizations);
    const currentOrganization = useSelector((state: RdxType) => state.organization?.currentOrganization);
    const myRoles = useSelector((state: RdxType) => state.organization?.myRoles);
    const [isOwnerOfCurrentOrganization, setIsOwnerOfCurrentOrganization] = useState<boolean>(OrganizationHelper.isOwnerOrHidden(myRoles?.[currentOrganization?.id ?? ""]?.role));

    useEffect(() => {
        const oid = currentOrganization?.id;
        if (!!oid) {
            setIsOwnerOfCurrentOrganization(OrganizationHelper.isOwnerOrHidden(myRoles?.[currentOrganization?.id ?? ""]?.role))
        } else {
            setIsOwnerOfCurrentOrganization(false)
        }
    }, [currentOrganization, myRoles]);



    return {
        isOwnerOfCurrentOrganization: isOwnerOfCurrentOrganization,

        switchToOrganization: (id: string) => {
            if (!!allOrganizations?.[id]) {
                dispatch({ type: CHANGE_ORGANIZATION_CURRENTORGANIZATION, payload: { ...allOrganizations?.[id] } });
            }
        },
        resetCurrentOrganization: () => {
            console.log("resetCurrentOrganization....")
            dispatch({ type: CHANGE_ORGANIZATION_CURRENTORGANIZATION, payload: {} });
        }
    }
}

export const useOrganization = () => {
    const user = useUser();
    const dispatch = useDispatch();
    const api = useOrganizationApi();

    const allOrganizations = useSelector((state: RdxType) => state.organization?.allOrganizations);
    const currentOrganization = useSelector((state: RdxType) => state.organization?.currentOrganization);
    const myRoles = useSelector((state: RdxType) => state.organization?.myRoles);
    const myUsers = useSelector((state: RdxType) => state.organization?.myUsers);
    const loadingOrganizations = useSelector((state: RdxType) => state.organization?.loadingOrganizations);

    const setLoadingOrganizations = (e: boolean) => {
        dispatch({ type: CHANGE_ORGANIZATIONS_LOADING_ORGANIZATIONS, payload: e });
    }

    const loadOrganizations = async () => {
        setLoadingOrganizations(true);
        const _selectedId = Cookies.get(COOKIENAME_CURRENT_ORGANIZATION_ID);

        const resp = await api.getMy();
        let orgs: { [key: string]: OrganizationType } = {};

        // All my organizations ------------------------------
        resp.items?.forEach(m => { orgs[m.organizationId] = m?.organization; });
        dispatch({ type: CHANGE_ORGANIZATIONS_ALL, payload: orgs });

        // Current Organization ------------------------------
        let currentSet = false;
        // Get from cookie
        if (!!_selectedId) {
            const n = resp.items?.find(m => m?.organizationId === _selectedId)?.organization;
            if (!!n) {
                dispatch({ type: CHANGE_ORGANIZATION_CURRENTORGANIZATION, payload: n });
                currentSet = true;
            }
        }
        // Get first
        if (currentSet === false && resp?.items?.length > 0) {
            const n = resp.items[0]?.organization;
            dispatch({ type: CHANGE_ORGANIZATION_CURRENTORGANIZATION, payload: n });
        }


        // My organization Roles ------------------------------
        let roles: { [key: string]: MyRolesType } = {};
        resp?.items?.map(m => {
            return {
                added: m?.myrole_added_epoch,
                organizationId: m?.organizationId,
                role: m?.myrole
            } as MyRolesType;
        }).forEach(r => {
            roles[r.organizationId] = r;
        });

        dispatch({ type: CHANGE_ORGANIZATIONS_MYROLES, payload: roles });

        // Org Users ------------------------------
        const users = await api.getMyUsers();
        dispatch({ type: CHANGE_ORGANIZATIONS_MYUSERS, payload: users.items });

        await user.loadUser();
        setLoadingOrganizations(false);
    }

    const getOrganizationProStatus = (id: string | undefined): OrganizationProStatus => {
        const _org = allOrganizations?.[id ?? ""];
        var _now = new Date().valueOf() / 1000;
        if ((_org?.premiumexpires ?? 0) > _now) { return "pro"; }
        if ((_org?.trialexpires ?? 0) > _now) { return "trial"; }
        return "basic";
    }

    return {
        loadingOrganizations: loadingOrganizations,
        allOrganizations: allOrganizations,
        currentOrganization: currentOrganization,
        currentOrganizationProStatus: getOrganizationProStatus(currentOrganization?.id),
        myOrganizationRoles: myRoles,
        getMyUsers: (orgId: string) => myUsers?.filter(m => m?.organizationId == orgId && m?.role !== "HIDDEN"),
        hasOrganizationSelected: !!(currentOrganization?.id),

        loadOrganizations: loadOrganizations,
        getOrganizationProStatus: getOrganizationProStatus,
        addOrganization: async (e: OrganizationType) => {

            setLoadingOrganizations(true);
            // Test
            await api.addOrganization(e);
            await loadOrganizations();
        },
        updateOrganization: async (e: OrganizationType, file: File | undefined, fileBg: File | undefined) => {
            setLoadingOrganizations(true);
            // Test
            await api.updateOrganization(e, file, fileBg);
            await loadOrganizations();
        },
        updateBillingInfo: async (orgId: string, model: OrderFormType) => {
            var ret = await api.updateBillingInfo(orgId, model);
            await loadOrganizations();
            return ret;
        },
        updateOrganizationContactInfo: async (e: OrganizationType, file: File | undefined, fileBg: File | undefined) => {
            setLoadingOrganizations(true);
            // Test
            await api.updateOrganizationContactInfo(e, file, fileBg);
            await loadOrganizations();
        },
        getUserName: (uid: string | undefined): string => {
            if (!!uid) {
                return myUsers.find(m => m?.id === uid)?.alias ?? "";
            }
            return "";
        }
    }
}

export const useMyOrganization = () => {
    const currentOrganization = useSelector((state: RdxType) => state.organization?.currentOrganization);
    return { ...currentOrganization }
}

export const useAddNewOrganization = () => {
    const addingNewOrganization = useSelector((state: RdxType) => state.ui?.addingNewOrganization);
    const dispatch = useDispatch();
    const params = useParams();
    const search = useLocation().search;
    const login = new URLSearchParams(search).get('login');

    const defaultState: AddingNewOrganizationViewStateType = login === "y" ? "login" : "createaccount";

    return {
        isAdding: addingNewOrganization?.isAdding,
        startAdd: () => {
            dispatch({ type: CHANGE_UI_ADDINGNEWORGANIZATION, payload: { isAdding: true } });
        },
        endAdd: () => {
            dispatch({ type: CHANGE_UI_ADDINGNEWORGANIZATION, payload: undefined });
        },

        organizationName: addingNewOrganization?.newOrganizationName ?? "",
        setOrganizationName: (e: string) => { dispatch({ type: CHANGE_UI_ADDINGNEWORGANIZATION, payload: { ...addingNewOrganization, newOrganizationName: e } }); },

        organizationEmail: addingNewOrganization?.newOrganizationEmail ?? "",
        setOrganizationEmail: (e: string) => { dispatch({ type: CHANGE_UI_ADDINGNEWORGANIZATION, payload: { ...addingNewOrganization, newOrganizationEmail: e } }); },

        viewState: addingNewOrganization?.addingViewState ?? defaultState,
        setViewState: (e: AddingNewOrganizationViewStateType) => { dispatch({ type: CHANGE_UI_ADDINGNEWORGANIZATION, payload: { ...addingNewOrganization, addingViewState: e } }); },
    }
}
export interface ApiGetOrganizationsType {
    items: IOrganizationWithMyRole[]
    count: number
    pageIndex: number
    pageSize: number
    totalCount: number
    success: boolean
    message: any
}

interface IOrganizationWithMyRole {
    organizationId: string
    myrole: string
    myrole_added_epoch: number
    organization: OrganizationType
}


const useOrganizationApi = () => {
    const f = useFetch();

    // api/organization
    return {
        addOrganization: async (e: OrganizationType) => {
            const d = await f.post("/api/organization", e);
            return d;
        },
        updateOrganizationContactInfo: async (e: OrganizationType, file: File | undefined, fileBg: File | undefined) => {
            let formData: FormData = new FormData();
            formData.append('file', file as File);
            formData.append('filebg', fileBg as File);
            formData.append('json', JSON.stringify(e));
            formData.forEach(function (value: any, key: string) {
                console.log("formData:", key, JSON.stringify(value));
            });
            const d = await f.postForm("/api/organization/" + e.id + "/contactinfo", formData);
            return d;
        },
        updateOrganization: async (e: OrganizationType, file: File | undefined, fileBg: File | undefined) => {
            let formData: FormData = new FormData();
            formData.append('file', file as File);
            formData.append('filebg', fileBg as File);
            formData.append('json', JSON.stringify(e));
            formData.forEach(function (value: any, key: string) {
                console.log("formData:", key, JSON.stringify(value));
            });
            const d = await f.postForm("/api/organization/" + e.id, formData);
            return d;
        },
        updateBillingInfo: async (orgId: string, model: OrderFormType) => {
            const data: RestResponseType = await f.patch("/api/organization/" + orgId + "/billinginfo", model);
            return data;
        },
        getMy: async () => {
            const d: ApiGetOrganizationsType = await f.get("/api/organization");
            return d;
        },
        getMyUsers: async () => {
            const d: RestListContainer<ApiOrganizationUserType> = await f.get("/api/organization/users");
            return d;
        },
    }
}

export type ApiOrganizationUserType = {
    id: string
    alias: string
    email: string
    role: OrganizationUserRoleType
    organizationId: string
    userState: OrganizationUserStateType
    profileImage: string
}
export type OrganizationUserStateType = "active" | "pending" | "none"
